import React from "react";
import {makeStyles, Typography} from "@material-ui/core";
import PageviewIcon from '@material-ui/icons/Pageview';
const useStyle = makeStyles((theme) => ({
    root: {
        display:'flex',
        flexDirection:'column',
        alignItems:'center',
        marginTop:'10rem',
        marginBottom:'10rem'
    }
}))
function NotFound() {
    const classes = useStyle();
    return (
        <div className={classes.root}>
            <PageviewIcon  color={'secondary'} fontSize={'large'}  />
            <Typography variant={'h2'} align={'center'} color={"textSecondary"}>Oops we cannot find this page.</Typography>
        </div>
    );
}

export default NotFound;
